<template>
  <div>
    <!--
    ************************************************
    Area de proceso de pago e informacion de reserva
    ************************************************
    -->
		<div class="container-fluid"
          style= "border-bottom_: 2px solid #ee8d2b; padding-bottom: 10px; background-color: #eeeeee">
			<!-- Una fila -->
      <div class="row">

        <!-- media fila der. Informacion reserva -->
				<div class="d-inline col-sm-12">

          <div class="">

            <!-- solo se pinta cuando se leen los datos almacenados en local storage -->
            <template v-if="cargado == true">

                <v-col class="columna">
                  <v-row cols="auto" class="mr-auto ml-auto tituloInfoReserva" align="center" justify="center">
                    {{ $t('resumenTitulo') }}
                  </v-row>

                  <div class="infoReserva">

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="nombreParking">{{ $t('inicioNombreParking') }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaFechaEntrada') }}</label>
                      <label class="datoInfoReserva">{{ fecha(datosReserva.fechaEntrada) }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaFechaSalida') }}</label>
                      <label class="datoInfoReserva">{{ fecha(datosReserva.fechaSalida) }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start" style="border-bottom: 1px solid rgb(240, 220, 220) ">
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start" style="margin-top: 10px;">
                      <label class="txtInfoReserva">{{ $t('datosReservaMatricula') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.matricula }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtInfoReserva">{{ $t('datosReservaModelo') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.modelo }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start" style="border-bottom: 1px solid rgb(240, 220, 220) ">
                    </v-row>


                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start" style="border-bottom: 1px solid rgb(240, 220, 220) ">
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start" style="margin-top: 10px;">
                      <label class="txtInfoReserva">{{ $t('datosReservaTarjeta') }}</label>
                      <label class="datoInfoReserva">{{ datosReserva.tarjeta }}</label>
                    </v-row>

                    <v-row cols="auto" class="mr-auto ml-auto" align="center" justify="start">
                      <label class="txtPrecio2">{{ $t('resumenImporteAbonado') }}</label>
                      <v-spacer></v-spacer>
                      <label class="total">{{ datosReserva.importeReserva  }} €</label>
                    </v-row>
                  </div>

                  <v-row cols="auto" class="mr-auto ml-auto politicas" align="center" justify="start">
                    *
                    <router-link to="/avisolegal" style="margin-left: 5px;" class="mr-2_">
                      <span style="white-space:nowrap;">{{ $t('condicionesUso') }}</span>
                    </router-link>
                    ,
                    <router-link to="/avisolegal" style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
                      <span style="white-space:nowrap;">{{ $t('politicaDevolucion') }}</span>
                    </router-link>
                    {{ $t('y') }}
                    <router-link to="/politicaprivacidad" style="margin-left: 5px;" class="mx-2_">
                      <span style="white-space:nowrap;">{{ $t('politicaprivacidad') }}</span>
                    </router-link>

                  </v-row>

                  <v-row cols="auto" class="mr-auto ml-auto avisoCorreo text-justify" align="center" justify="start">
                    {{ $t('resumenAvisoDevolucion') }}
                  </v-row>
                </v-col>


                <v-overlay v-model="dialog">
                  <v-progress-circular
                    size="120"
                    width="12"
                    color="red"
                    indeterminate
                    justify="center"
                    align="center">
                  </v-progress-circular>
                </v-overlay>

                  <v-alert style="margin-bottom:10px;"
                        :value="alerta.mostrar"
                        :color="alerta.color"
                        dark
                        border="top"
                        icon="mdi-car-off"
                        transition="scale-transition"
                  >
                    {{ this.alerta.texto }}
                  </v-alert> <!-- para mostrar mensaje de error de comunicacion -->


                  <!-- muestra un boton u otro en funcion de el numero de veces que se carga una
                      pagina en el iframe. Sirve para detectar cuando se recibe la urlok o urlko -->
                  <template v-if="botonPulsado == false">
                    <v-btn
                      class="mx-auto"
                      outlined
                      color="black"
                      @click="cancelarReserva()"
                    >
                     {{ $t('menuCancelar') }}
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn
                      class="mx-auto "
                      outlined
                      color="black"
                      @click="finalizarCancelacionReserva()"
                    >
                      {{ $t('btnTerminar') }}
                    </v-btn>
                  </template>

            </template>
            <template v-else>
              <p>Cargando!!!</p>
            </template>

          </div> <!-- fin titulo Completa tu reserva -->

				</div> <!-- fin media linea der Formulario Reserva -->

      </div> <!-- fin linea -->

		</div>  <!-- fin area de reserva -->



  </div>
</template>


<style scoped>

  .tituloInfoReserva {
    padding: 10px;
    background-color: white;
    color: #4894ef;
    border-bottom: 1px solid rgb(240, 220, 220);
  }

  .pieInfoReserva {
    padding: 10px;
    background-color: #4894ef;
    color: white;
  }

  .infoReserva {
    background-color: white;
    color: black;
  }

  .nombreParking {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    font-size: 16px;
  }

  .titReservaConfirmada {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;

    font-size: 20px;
    font-weight: bold;
  }

  .txtInfoReserva {
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
  }

  .datoInfoReserva {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
  }

  .txtPrecio {
    margin-left: 10px;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
  }

  .txtPrecio2 {
    margin-left: 10px;
    margin-top: 0px;
    font-size: 16px;
    font-weight: bold;
  }


  .subTotal{
    margin-left: 10px;
    margin-right: 10px;
    font-size: 10px;
  }

  .total{
    margin-left: 10px;
    margin-right: 20px;
    font-size: 40px;
    color:#4894ef;
    font-weight: bold
  }

  .iconoPieInfo{
    font-size:25px;
    color:white;
    margin-right: 10px;
  }

  .politicas{
    margin-top: 20px;
    font-size: 12px;
    font-weight: normal;
    color: #4894ef;
  }

  .avisoCorreo{
    margin-top: 20px;
    font-size: 12px;
    font-weight: bold;
    color: black;
  }

  .contacto{
    margin-top: 20px;
    font-size: 12px;
    font-weight: normal;
    color: black;
  }


 .entradaDatosUnico {
    margin-left: 5px;
    margin-right: 5px;
  }

 .desplegableDatosFacturacion {
    margin-left: 2%;
    margin-right: 2%;
  }


</style>




<script>
// comunicacion HTTP con RestApi
import api from '@/plugins/api.js'

// constantes para todo el proyecto
import { escribirLog } from '@/plugins/utilidades.js'


export default {
  name: "PaginaCancelarReserva",

  data: () => ({
    // indicador de que se ha recuperado los datos de reserva de localStorage
    cargado: false,

    dialog: false,

    // indica si se ha intentado ya la cancelacion
    botonPulsado: false,

    alerta: {
      mostrar: false,
      texto: '',
      color: 'pink'
    }, //fin objeto alerta

    datosReserva: {
      importeReserva: "",
      fechaEntrada: null,
      fechaSalida: null,
      matricula: "",
      modelo: "",
      idReservaBD: -1,
      merchant_order: "",
      localizador: "",
      codinsclo: -1,
      tarjeta:"",

    }, // fin objeto data.datosReserva
  }),

  methods: {
    fecha: function(aFecha){
      // devuelve formateadas y traducidad las fechas de entrada y salida

      var txtFecha = '';
      var ffecha = this.$moment(aFecha);

      if ('en' == this.$i18n.locale){
        txtFecha = ffecha.locale(this.$i18n.locale).format("dddd, MMMM Do YYYY, HH:mm");
      } else {
        txtFecha = ffecha.locale(this.$i18n.locale).format("dddd, DD MMMM YYYY, HH:mm");
      }

      return txtFecha;

    }, // fin metodo fecha


    finalizarCancelacionReserva: function(){

      this.dialog = false;
      // cambio de pagina
      this.$router.push({ path: '/' })

    },  // fin metodo finalizarCancelacionReserva


    cancelarReserva: function(){

      this.alerta.mostrar = false;
      this.alerta.texto = "";

      this.dialog = true;

      const datosPeticion = {
				"codinsclo": this.datosReserva.codinsclo,
        "locator": this.datosReserva.localizador,
        "id_reserva": this.datosReserva.idReservaBD
      };
      /* orden al parking, via backend, para que cancele una reserva.
         Incluye marcar la reserva como cancelada por el usuario en la base de datos
         y la devolucion del importe */
      api.cancelarReserva(datosPeticion)
        .then(response => {

          if (200 == response.status) {
              if (0 == response.data.estado){
                // dinero devuelto
                this.alerta.color = "green";
                this.alerta.mostrar = true;
                this.alerta.texto = this.$t('reservaCancelada');
              } else {
                this.alerta.mostrar = true;
                this.alerta.texto = response.data.mensaje;
              }

          } else {
            this.dialog = false;
            this.alerta.mostrar = true;
            this.alerta.texto = response.data.error_message;
            this.botonPulsado = true;
          }

        })
        .catch(error => {
          escribirLog('Error cancelarReserva')
          escribirLog(error);

          this.dialog = false;
          this.alerta.mostrar = true;
          this.alerta.texto = error;
          this.botonPulsado = true;

          /* reserva NO cancelada en el parking. Habria que notificarlo al encargado para que
            lo haga manualmente */
        })
        .finally(() => {
          escribirLog('Final cancelarReserva');
          this.dialog = false;
          this.botonPulsado = true;
       })

      escribirLog('Fin cancelar');

    }, // fin metodo cancelarReserva

  }, // fin methods


  mounted: function() {
    // recuperamos los datos de la reserva almacenados en local por la pantalla anterior

    this.datosReserva.importeReserva = window.localStorage.getItem("importeReserva");
    // las fechas de entrada/salida incluyen la informacion de la hora
    this.datosReserva.fechaEntrada = window.localStorage.getItem("fechaEntrada");
    this.datosReserva.fechaSalida = window.localStorage.getItem("fechaSalida");
    this.datosReserva.matricula = window.localStorage.getItem("matricula");
    this.datosReserva.modelo = window.localStorage.getItem("modelo");
    this.datosReserva.nombre = window.localStorage.getItem("nombre");
    this.datosReserva.mail = window.localStorage.getItem("mail");
    this.datosReserva.telefono = window.localStorage.getItem("telefono");

    this.datosReserva.idReservaBD = window.localStorage.getItem("idReservaBD");
    this.datosReserva.localizador = window.localStorage.getItem("localizador");
    this.datosReserva.codinsclo = window.localStorage.getItem("codinsclo");
    this.datosReserva.tarjeta = window.localStorage.getItem("tarjeta");

    this.cargado = true;

    window.scrollTo(0,0);
  }, // fin evento mounted




};
</script>
